import { Container, Grid } from "@mui/material";
import React, { Component } from "react";
import Api from "src/services/api";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@mui/styles';
import { Styles } from 'src/styles/material-styles';
import CustomizedSnackbars from 'src/components/material-snackbars';
import { injectIntl } from "react-intl";
import { AbilityContext } from "src/config/ability-context";
import PropTypes from 'prop-types';
import * as articleActions from 'src/redux/actions/articles';
import Header from "src/components/header-external";
import { PapiroConsole } from "src/utils/papiroConsole";
import BlockCard from "./components/block-card";
import Footer from "src/components/footer-external";
import Modal from "src/components/modal-external/modal-principal";
import * as FileService from 'src/services/attachment.service';

import CalledServicesSettingsExternalFormList from "./components/called-services-settings-external-form-list";
import CommonSearchExternal from "src/components/client-portal/common-search-external";
import SkeletonCommonExternalDynamicArticles from "src/components/client-portal/skeleton-common-external-dynamic-articles";
import CommonExternalDynamicArticles from "src/components/client-portal/common-external-dynamic-articles";
import BlockCardSkeleton from "./components/block-card-skeleton";

import LogoMarca from 'src/images/new-logo2-cmtech.png'
import KnowledgeBaseAttachmentsDialog from "src/components/client-portal/common-knowledget-base-attachments-dialog";

const classes2 = () => {
    return withStyles({
        ImageList: {
            width: "100%",
            height: 100,
        },
    });
}

class ClientPortalExternal extends Component {
    constructor(props) {
        super(props)
        const { userSession } = this.props;
        PapiroConsole.log("ClientPortal userSession")
        PapiroConsole.log(userSession)

        this.initalState = {
            id: 0,
            title: '',
            showtitle: false,
            enablelogin: false,
            enablesearch: '',
            enablecreatecalled: false,
            searchtext: '',
            defaultcolor: '',
            clientportalblocks: [],
            showpromotedarticles: false,
            promotedarticlesamount: 0,
            showrecentarticles: false,
            recentarticlesamount: 0,
            showmostviewedarticles: false,
            mostviewedarticlesamount: 0,
            showbestratedarticles: false,
            bestratedarticlesamount: 0,
            footertext: '',
            footerphone: '',
            footeremail: '',
            showinstagram: '',
            instagramlink: '',
            showlinkedin: '',
            linkedinlin: '',
            showyoutube: '',
            youtubelink: '',
            showfacebook: '',
            facebooklink: '',
            defaulttextcolor: '',
            enablewebchat: false,
            enablefaq: false
        }

        this.state = {
            item: this.initalState,
            hirerid: 0,
            loading: false,
            loadingInternal: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            searchvalue: '',
            promotedarticles: [],
            bestratedarticles: [],
            mostviewedarticles: [],
            recentarticles: [],
            createCalledDialogOpen: false,
            calledServiceSettingsList: [],
            knowledgeBaseDialogOpen: false,
            knowledgeBaseDialogItem: { knowledgebaseknowledgebasekeywords: [], knowledgebaseattachments: [] },
            mainimagesrc: '',
            appName: Api != null ? Api.getAppName() : "CMTECH - Mexx 2DO",
            logoimagesrc: '',
            channelwebchat: {},
        }

        this.handleChange = this.handleChange.bind(this)
        this.openKnowledgeBaseDialog = this.openKnowledgeBaseDialog.bind(this)
        this.openCreateCalledDialog = this.openCreateCalledDialog.bind(this)
        this.closeKnowledgeBaseDialog = this.closeKnowledgeBaseDialog.bind(this)
        this.closeCreateCalledDialog = this.closeCreateCalledDialog.bind(this)
        this.setNotification = this.setNotification.bind(this)
        this.copyFileLink = this.copyFileLink.bind(this)
        this.downloadFile = this.downloadFile.bind(this)
        this.searchArticle = this.searchArticle.bind(this)
    }

    async componentDidMount() {
        document.title = this.state.appName;
        this.setState({ loading: true })
        await this.getHirerId()
        await this.getPortal()
        await this.getBlocks()
        this.setState({ loading: false })
    }

    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value

        this.setState({
            [name]: value
        })
    }

    setNotification = (openNotification, notificationVariant, notificationMessage) => {
        this.setState({
            openNotification: openNotification,
            notificationVariant: notificationVariant,
            notificationMessage: notificationMessage,
        })
    }

    getHirerId = async () => {
        const intl = this.props.intl

        await Api.get(`/configs/cancreateclientusersexternal`)
            .then(result => {
                if (result.data.success) {
                    if (result.data.data != null) {
                        if (result.data.data.hirerid != null && result.data.data.hirerid > 0)
                            this.setState({ hirerid: result.data.data.hirerid })
                        else {
                            var l = this.props.match.params.lang;
                            document.location.href = `/${l}/unavailable`
                        }
                    }
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err)
            })
    }

    getImageFile = async (image, stateKey) => {
        try {
            const response = await fetch(image.anonymoustoken)

            if (!response.ok) {
                throw new Error('Erro ao buscar o link da imagem')
            }

            const json = await response.json()

            if (json?.data) {
                const imageUrl = json.data
                this.setState({ [stateKey]: imageUrl })
            }
        } catch (e) {
            PapiroConsole.log('Erro ao carregar imagem')
        }
    }

    getPortal = async () => {
        const intl = this.props.intl

        await Api.get(`/clientportal/external/hirer/${this.state.hirerid}`)
            .then(result => {
                if (result.data && result.data.success) {
                    const data = result.data.data;

                    this.setState({
                        item: data
                    })
                    if (data.logoimage) {
                        this.getImageFile(data.logoimage, 'logoimagesrc')
                    } else {
                        const image = Api.getLoginImage()
                        if (image) {
                            this.getImageFile(image, 'logoimagesrc')
                        } else {
                            this.setState({ logoimagesrc: LogoMarca })
                        }
                    }
                    if (data.mainimage) {
                        this.getImageFile(data.mainimage, 'mainimagesrc')
                    }
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result.data)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(err)
            })
    }

    getBlocks = async () => {
        const intl = this.props.intl

        await Api.get(`clientportalblocks/clientportal/${this.state.item.id}`)
            .then(result => {
                if (result.data.success) {
                    this.setState((prevState) => ({
                        ...prevState,
                        item: {
                            ...prevState.item,
                            clientportalblocks: result.data.data
                        }
                    }))
                }
                else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result.data)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(err)
            })
    }

    openKnowledgeBaseDialog = async (knowledgebaseid) => {
        const intl = this.props.intl
        this.setState({ loadingInternal: true })

        await Api.get(`knowledgebases/details/external/${knowledgebaseid}`)
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        knowledgeBaseDialogItem: result.data.data
                    })
                }
                else {
                    this.setState({
                        loadingInternal: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result.data)
                }
            })
            .catch(err => {
                this.setState({
                    loadingInternal: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(err)
            })

        this.setState({ loadingInternal: false })
        this.setState({ knowledgeBaseDialogOpen: true })
    }

    openCreateCalledDialog = (calledServiceSettingsList) => {
        this.setState({
            createCalledDialogOpen: true,
            calledServiceSettingsList: calledServiceSettingsList
        })
    }

    closeKnowledgeBaseDialog = () => {
        this.setState({ knowledgeBaseDialogOpen: false })
    }

    closeCreateCalledDialog = () => {
        this.setState({ createCalledDialogOpen: false })
    }

    closeNotification = () => {
        this.setState({ openNotification: false })
    }

    copyFileLink = async (attachment) => {
        const { intl } = this.props

        let url = await FileService.getFileDownloadLink(attachment.id);

        if (url && url.data && url.data.data && url.data.success) {
            navigator.clipboard.writeText(url.data.data)
            this.closeKnowledgeBaseDialog();
            this.setNotification(true, "success", "Link de download copiado!")
        } else {
            this.closeKnowledgeBaseDialog();
            this.setNotification(true, "error", intl.formatMessage({ id: "file.not.found" }))
        }
    }

    downloadFile = async (attachment) => {
        const { intl } = this.props

        let url = await FileService.getFileDownloadLink(attachment.id);
        if (url && url.data && url.data.data && url.data.success) {
            window.open(`${url.data.data}`, '_blank')
        } else {
            this.setNotification(true, "error", intl.formatMessage({ id: "file.not.found" }))
        }
    }

    searchArticle = () => {
        this.props.addCurrentSearch(this.state.searchvalue)
        this.props.history.push(`/${this.props.match.params.lang}/article-list-external`)
    }

    render() {

        const { classes, intl } = this.props
        const { item, hirerid, logoimagesrc, mainimagesrc } = this.state
        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`
        }

        return (
            <div className={classes.root}>
                <main
                    className={classes.contentExternal}
                >
                    <Container style={{ maxWidth: '100vw', width: '100vw', margin: 0, paddingInline: 0 }}>

                        <Grid container width="100%" direction="column" justifyContent="space-between" minHeight="100vh">
                            <Grid item container>
                                <Header
                                    intl={this.props.intl}
                                    clientportal={item}
                                    calledservicesettings={item.calledservicesettingsclientportals}
                                    language={this.props.match.params.lang}
                                    openCreateCalledDialog={this.openCreateCalledDialog}
                                    logoimagesrc={logoimagesrc}
                                    loading={this.state.loading}
                                />

                                <CommonSearchExternal
                                    state={this.state}
                                    clientportal={item}
                                    loading={this.state.loading}
                                    mainImageSrc={mainimagesrc}
                                    nameTextField={"searchvalue"}
                                    handleChange={this.handleChange}
                                    searchArticle={this.searchArticle}
                                />

                                <Grid item container marginX="20vw" spacing={5} mt={1}>
                                    {this.state.loading && <BlockCardSkeleton />}

                                    <Grid item container spacing={3} justifyContent="center" alignItems="center">
                                        {!this.state.loading && this.state.item.clientportalblocks && this.state.item.clientportalblocks.map(block => {
                                            return (
                                                <BlockCard
                                                    key={block.id}
                                                    block={block}
                                                    openKnowledgeBaseDialog={this.openKnowledgeBaseDialog}
                                                />
                                            )
                                        })}
                                    </Grid>
                                </Grid>

                                <Grid container marginX="20vw" spacing={5} mt={1}>
                                    <SkeletonCommonExternalDynamicArticles loading={this.state.loading} />

                                    {!this.state.loading &&
                                        <CommonExternalDynamicArticles
                                            clientportal={this.state.item}
                                            hirerid={this.state.hirerid}
                                            setNotification={this.setNotification}
                                        />
                                    }
                                </Grid>
                            </Grid>
                            <Footer
                                intl={intl}
                                clientportal={this.state.item}
                                loading={this.state.loading}
                                setLoading={loading => this.setState({ loading: loading })}
                            />
                        </Grid>

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />

                        <KnowledgeBaseAttachmentsDialog
                            open={this.state.knowledgeBaseDialogOpen}
                            onClose={this.closeKnowledgeBaseDialog}
                            knowledgeBaseItem={this.state.knowledgeBaseDialogItem}
                            clientportal={this.state.item}
                            classes={classes}
                            classes2={classes2}
                            getCalledFile={this.getCalledFile}
                            copyFileLink={this.copyFileLink}
                            loading={this.state.loadingInternal}
                        />

                        <Modal
                            intl={intl}
                            title={<strong style={{ color: this.state.item.defaulttextcolor }}>{this.state.item.createcalledpagetitle || intl.formatMessage({ id: "choose.form" })}</strong>}
                            open={this.state.createCalledDialogOpen}
                            onClose={this.closeCreateCalledDialog}
                            contentPadding={false}
                            maxWidth="md"
                            children={
                                <CalledServicesSettingsExternalFormList
                                    calledServiceSettingsList={this.state.calledServiceSettingsList}
                                    clientportal={item}
                                />
                            }
                        />
                    </Container>
                </main>
            </div>
        )
    }
}

ClientPortalExternal.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    userSession: state.userSession,
})

const mapDispatchToProps = dispatch =>
    bindActionCreators(articleActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ClientPortalExternal)));
ClientPortalExternal.contextType = AbilityContext;